import { SignupFormCard } from "@/features/auth/components/signup-form-card";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/signup")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex items-center justify-center min-h-screen p-4 sm:p-0">
      <SignupFormCard />
    </div>
  );
}
